module.exports = __webpack_public_path__ + "img/1_023.a0fcfd34.jpg";